import filter from '@/api/filter';
export const config = {
  data() {
    return {
      columns: []
    };
  },
  methods: {
    getColumns() {
      let columns = [
        {
          title: '原保单号',
          slot: 'policyNo',
          align: 'center',
          width: 220,
          fixed: 'left'
        }
      ];
      if (this.searchParams.payState == 1) {
        // 即将到期
        columns = columns.concat([
          {
            title: '保单到期日',
            width: 180,
            align: 'center',
            slot: 'endDesc',
          },
          {
            title: '产品名称',
            width: 300,
            slot: 'productName',
            align: 'center'
          }
        ]);
      } else if (this.searchParams.payState == 2) {
        // 已续保
        columns = columns.concat([
          {
            title: '续保保单号',
            width: '140',
            align: 'center',
            fixed: 'left',
            slot: 'newPolicyNo'
          },
          {
            title: '产品名称',
            width: 300,
            slot: 'productName',
            align: 'center'
          }
        ]);
      } else if (this.searchParams.payState == 3) {
        // 未续保
        columns = columns.concat([
          {
            title: '保单到期日',
            width: 110,
            align: 'center',
            key: 'endTime',
            render(h, params) {
              const result = filter.filterTime(params.row.endTime, 'YYYY-MM-DD');
              return <span>{result}</span>;
            }
          },
          {
            title: '产品名称',
            width: 300,
            slot: 'productName',
            align: 'center'
          }
        ]);
      }
      if (this.$units.showSupplier() && this.$units.pointAction('renewalManage_04_10')) {
        columns = columns.concat([
          {
            title: '供应商',
            width: '140',
            align: 'center',
            key: 'supplierName'
          }
        ]);
      }
      columns = columns.concat([
        {
          title: '投保人',
          width: 180,
          align: 'center',
          ellipsis: true,
          tooltip: true,
          slot: 'holderName'
        },
        {
          title: '原单状态',
          align: 'center',
          minWidth: 100,
          tooltip: true,
          key: 'policyStatusDesc'
        }
      ]);
      if (this.searchParams.payState == 3) {
        // 未续保
        columns = columns.concat([
          {
            title: '未续保原因',
            align: 'center',
            minWidth: 200,
            tooltip: true,
            key: 'remark'
          }
        ]);
      }
      if (this.searchParams.payState == 1 || this.searchParams.payState == 3) {
        // 即将到期、未续保
        columns = columns.concat([
          {
            title: '原单保费(元)',
            width: 170,
            align: 'center',
            ellipsis: true,
            tooltip: true,
            render(h, params) {
              return <span>{params.row.fee}</span>;
            }
          },
          {
            title: '原单服务费（元）',
            width: 120,
            key: 'commissionPrice',
            align: 'center',
            ellipsis: true,
            tooltip: true
          },
        ]);
      } else if (this.searchParams.payState == 2) {
        // 已续保
        columns = columns.concat([
          {
            title: '保单到期日',
            width: 110,
            align: 'center',
            ellipsis: true,
            tooltip: true,
            render(h, params) {
              const result = filter.filterTime(params.row.endTime, 'YYYY-MM-DD');
              return <span>{result}</span>;
            }
          },
          {
            title: '原单保费/续保保费(元)',
            width: 170,
            align: 'center',
            ellipsis: true,
            tooltip: true,
            render(h, params) {
              return (
                <span>
                  {params.row.fee}/{params.row.payFee || '-'}
                </span>
              );
            }
          },
          {
            title: '原单服务费/新单服务费（元）',
            width: 200,
            key: 'commissionPrice',
            align: 'center',
            render(h, params) {
              return (
                <span>
                  {params.row.commissionPrice}/{params.row.newCommissionPrice || '-'}
                </span>
              );
            }
          },
        ]);
      }
      columns = columns.concat([
        
        {
          title: '机构/业务员',
          align: 'center',
          minWidth: 200,
          tooltip: true,
          render(h, params) {
            return (
              <span>
                {params.row.orgName}/{params.row.salesmanName}
              </span>
            );
          }
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: '220',
          fixed: 'right'
        }
      ]);
      this.columns = columns;
    }
  }
};
